function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKKEY opcode — object key presence / allowlist / denylist.
 *
 * Language shape:
 *   script.field     — object path (e.g. "db")
 *   script.operator  — "==" | "!=" | "IN" | "NOT"
 *   script.key       — string key name (== / !=) OR array of key names (IN / NOT)
 *
 * IN  → every key present on the object is in the supplied list
 * NOT → none of the supplied keys is present on the object
 */

module.exports = {
  name: 'CHECKKEY',
  description: "\nTests object keys (never values).\n\n==   \u2192 key exists\n!=   \u2192 key does not exist\nIN   \u2192 every key present on the object is in the supplied list\nNOT  \u2192 none of the supplied keys is present on the object\n",
  exampleScript: {
    op: 'CHECKKEY',
    field: 'db',
    operator: 'IN',
    key: ['field1', 'field2', 'field3']
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var operator = node.operator;
    if (typeof operator !== 'string' || operator.length === 0) {
      return false;
    }
    var object = resolveRef(context, node.field);
    if (!object || _typeof(object) !== 'object' || Array.isArray(object)) {
      return false;
    }
    if (operator === '==' || operator === '!=') {
      var keyName = resolveRef(context, node.key);
      if (typeof keyName === 'string' && Object.prototype.hasOwnProperty.call(context, keyName)) {
        keyName = context[keyName];
      }
      if (typeof keyName !== 'string' || keyName.length === 0) {
        return false;
      }
      var present = Object.prototype.hasOwnProperty.call(object, keyName);
      if (operator === '==') {
        return present === true;
      }
      return present === false;
    }
    if (operator === 'IN' || operator === 'NOT') {
      var list = node.key;
      if (typeof list === 'string') {
        list = resolveRef(context, list);
      }
      if (!Array.isArray(list)) {
        return false;
      }
      var names = [];
      for (var i = 0; i < list.length; i += 1) {
        var item = resolveRef(context, list[i]);
        if (typeof item === 'string' && Object.prototype.hasOwnProperty.call(context, item)) {
          item = context[item];
        }
        if (typeof item !== 'string') {
          return false;
        }
        names.push(item);
      }
      var objectKeys = Object.keys(object);
      if (operator === 'IN') {
        for (var _i = 0; _i < objectKeys.length; _i += 1) {
          if (names.indexOf(objectKeys[_i]) === -1) {
            return false;
          }
        }
        return true;
      }
      for (var _i2 = 0; _i2 < names.length; _i2 += 1) {
        if (Object.prototype.hasOwnProperty.call(object, names[_i2])) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
};
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}